module.exports = __webpack_public_path__ + "img/iconArrowWhite.eff9d3a7.svg";